import { gql } from 'graphql-request';

export default gql`
  fragment ActivitySchedule on ActivitySchedule {
    id
    activity {
      id
    }
    ... on ActivitySchedule {
      maandag: mondayTimes {
        ... on TimeFrameBlock {
          startTime
          endTime
        }
      }
      dinsdag: tuesdayTimes {
        ... on TimeFrameBlock {
          startTime
          endTime
        }
      }
      woensdag: wednesdayTimes {
        ... on TimeFrameBlock {
          startTime
          endTime
        }
      }
      donderdag: thursdayTimes {
        ... on TimeFrameBlock {
          startTime
          endTime
        }
      }
      vrijdag: fridayTimes {
        ... on TimeFrameBlock {
          startTime
          endTime
        }
      }
      zaterdag: saturdayTimes {
        ... on TimeFrameBlock {
          startTime
          endTime
        }
      }
      zondag: sundayTimes {
        ... on TimeFrameBlock {
          startTime
          endTime
        }
      }
      extraInfoBody
      extraInfoButtonText
      extraInfoButtonUrl
    }
  }
`;
